
import FilesUploader from './files-uploader.vue'
import AvatarUploader from './avatar-uploader.vue'
import SampleUploader from './sample-uploader.vue'

export default {
  components: {FilesUploader, AvatarUploader, SampleUploader},
  props: {
    mode: {
      type: String,
      default: 'files',
      validator(value) {
        return ['files', 'avatar', 'inline-text'].includes(value)
      },
    },
    maxSize: {
      type: Number,
      required: true,
    },
    maxUploads: {
      type: Number,
      default: undefined,
    },
    accept: {
      type: String,
      required: true
    },
    storeType: {
      type: String,
      required: true,
    },
    storeTag: {
      type: String,
      required: true,
    },
    txtRows: {
      type: Number,
      default: 5,
    },
    fileRows: {
      type: Number,
      default: 4,
    },
  },
  emits: ['uploaded', 'removed'],
  methods: {
    handleUpload(result) {
      this.$emit('uploaded', result)
    },
    handleRemove(file_id) {
      this.$emit('removed', file_id)
    },
  },
}
